const VERSION_CHECK_INTERVAL = 30000;
const VERSION_FILE_PATH = '/version.json';

let checkInterval = null;
let currentVersion = null;
let isPageVisible = true;
let router = null;

function getCurrentVersion() {
  const metaTag = document.querySelector('meta[name="app-version"]');
  if (metaTag) {
    return metaTag.getAttribute('content');
  }
  return currentVersion || null;
}

async function checkVersion() {
  if (!isPageVisible) {
    return;
  }
  
  try {
    const response = await fetch(`${VERSION_FILE_PATH}?t=${Date.now()}`, {
      cache: 'no-store',
    });
    
    if (!response.ok) {
      return;
    }
    
    const data = await response.json();
    const serverVersion = data.version;
    const localVersion = getCurrentVersion();
    
    if (localVersion && serverVersion && serverVersion !== localVersion) {
      console.log('Обнаружена новая версия приложения. Перезагрузка...');
      window.location.reload();
    }
  } catch (error) {
    console.debug('Проверка версии:', error.message);
  }
}

function startVersionCheck() {
  if (checkInterval) {
    return;
  }
  
  currentVersion = getCurrentVersion();
  
  if (!currentVersion) {
    console.warn('Версия приложения не найдена');
    return;
  }
  
  checkInterval = setInterval(checkVersion, VERSION_CHECK_INTERVAL);
  
  checkVersion();
}

function stopVersionCheck() {
  if (checkInterval) {
    clearInterval(checkInterval);
    checkInterval = null;
  }
}

function handleVisibilityChange() {
  isPageVisible = !document.hidden;
  
  if (isPageVisible) {
    checkVersion();
  }
}

function handleFocus() {
  checkVersion();
}

export default {
  install(app, options) {
    if (typeof window === 'undefined') {
      return;
    }
    
    router = options?.router || app.config.globalProperties.$router;
    
    app.mixin({
      mounted() {
        if (this.$el === this.$root.$el) {
          setTimeout(() => {
            startVersionCheck();
            
            document.addEventListener('visibilitychange', handleVisibilityChange);
            window.addEventListener('focus', handleFocus);
            
            if (router) {
              router.afterEach(() => {
                setTimeout(checkVersion, 1000);
              });
            }
          }, 2000);
        }
      },
      beforeUnmount() {
        if (this.$el === this.$root.$el) {
          stopVersionCheck();
          document.removeEventListener('visibilitychange', handleVisibilityChange);
          window.removeEventListener('focus', handleFocus);
        }
      },
    });
  },
};

